// CookieOverlay.js
import React, { useEffect }  from 'react';
//import DOMPurify from 'dompurify';


const CookieOverlay = ({ cookieOverlayTitle = '', cookieOverlayDescription = '', cookiePreferencesButtonText = '', cookieOverlaySubtext = '', cookieOverlayBackgroundColor = ''}) => {

	useEffect(() => {
		window.applicationReInit(['CookieHandler']);
	}, []);
	

	return (
		<div className={`c-cookie-overlay cookie-disclosure is-enabled l-container  l-container--full-width ${cookieOverlayBackgroundColor}`}>
			<div className="l-grid l-grid--max-width">
				<div className="l-grid__row">
					<div className="c-cookie-overlay__content l-grid__column-large-8 l-grid__column-small-12 l-grid__column-medium-12">
						<h3 className="component-title c-heading c-heading--link-black">
							{cookieOverlayTitle}
						</h3>
						<p className="c-copy c-cookie-overlay__text ">
							{cookieOverlayDescription}
						</p>
						<button className="c-button optanon-toggle-display" data-component-id="root/parsys/wrapper/wrapper/onetrust_cookie_sett">
							{cookiePreferencesButtonText}
						</button>
						<p className="c-copy c-cookie-overlay__text u-margin-bottom-0">
							{cookieOverlaySubtext}
						</p>

					</div>
				</div>
			</div>
		</div>
	)
};

export default CookieOverlay;
